<div class="flex gap-3 items-center">
	@if (icon(); as icon) {
		<mar-icon size="m" [name]="icon" />
	}

	<h2 class="text-2xl font-semibold flex-1">
		@if (label(); as label) {
			@if (typeof label === 'string') {
				{{ label | transloco }}
			} @else if (label.translate) {
				{{ label.text | transloco }}
			} @else {
				{{ label.text }}
			}
		}
	</h2>

	<ng-content />
</div>

@if (description(); as description) {
	<p class="max-w-4xl text-lg">
		{{ description | transloco }}
	</p>
}
